import { render, staticRenderFns } from "./EndPage.vue?vue&type=template&id=a8691ffe&scoped=true"
import script from "./EndPage.vue?vue&type=script&lang=js"
export * from "./EndPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8691ffe",
  null
  
)

export default component.exports